module.exports = __webpack_public_path__ + "img/sl.299fcb82.png";